import 'dayjs/locale/zh-cn'
import locale from 'antd/lib/date-picker/locale/zh_CN'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'

dayjs.extend(weekday)
dayjs.locale('zh-cn')
dayjs.extend(localeData)

type PropType = {
  value?: any
  onChange?: (e: any) => void
  picker?: 'date' | 'week' | 'month' | 'quarter' | 'year'
  showTime?: boolean
}
const CustomedDatePicker: React.FC<PropType> = ({ value, onChange, picker, showTime }) => {
  if (!showTime) {
    return <DatePicker value={value} picker={picker} locale={locale} onChange={onChange} />
  }
  // 带时间的弹层很高,Windows 缩放 125%/150% 时底部「确定」会落到视口外。
  // needConfirm=false:点日期/时间即生效,点外面关闭,不依赖那个按钮;
  // 只选到分钟:秒那一列对比赛时间没意义,去掉后弹层更窄更矮。
  return (
    <DatePicker
      value={value}
      picker={picker}
      showTime={{ format: 'HH:mm' }}
      format="YYYY-MM-DD HH:mm"
      needConfirm={false}
      placeholder="请选择日期和时间"
      locale={locale}
      onChange={onChange}
    />
  )
}

export default CustomedDatePicker
